import { Divider, Grid, Stack } from '@mui/material';
import MovieCard from 'src/components/stComponents/MovieCard';
import { useEffect, useState } from 'react';
import SteLib, {POPUP_INITDATA} from 'src/lib/stelib';
import { useOutletContext } from "react-router-dom";
import MovieCardDesktop from 'src/components/stComponents/MovieCardDesktop';
import BookPopup from 'src/components/stComponents/BookPopup';
import Carousel from 'src/components/stComponents/Carousel';

export default function HomePage({setToken}) {
  const [firstTime, setFirstTime] = useState(true);
  const [movies, setMovies] = useState([]);
  const [isMobile ] = useOutletContext();

  const [BP_data, BP_setData] = useState(POPUP_INITDATA);

  useEffect(() => {
    if(firstTime)
    {
      getMovies();
    }
    setFirstTime(false);
  }, [firstTime]);

  const getMovies = () => {
    SteLib.GetRequest("movies", {}, true).then((data) => {
      setMovies(data)
      console.log(data)
    });
  }

  let onTimeSlotClick = (movie, slot, date) => {
    BP_setData({...BP_data, open: true, movie: movie, slot: slot, date: date});
  }

  return (
    <>
        <Stack alignContent={"center"} style={{padding: isMobile ? "0" : "0 2rem"}}>
            <Carousel></Carousel>
            { isMobile ? 
            <div style={{textAlign: "center"}}>
              <h2><b>PROIEZIONI PROGRAMMATE</b></h2> 
            </div>   :
            <div style={{textAlign: "center", padding: "0 2rem 1rem 2rem"}}>
              <Divider><h2><b>PROIEZIONI PROGRAMMATE</b></h2></Divider>
              
            </div>}
            { isMobile ?
              Array.isArray(movies) && movies.length > 0 ?  
              <Grid justifyContent="center" alignItems="center" container spacing={4}>
                {Array.isArray(movies) && movies?.map(d => {
                  return (
                    <Grid item key={d.id}>
                      <MovieCard onTimeSlotClick={onTimeSlotClick} movieData={d}></MovieCard>
                    </Grid>)
                })}
              </Grid> : 
              <div style={{color: "#b3b3b3", margin: "4rem 0", width: "100%", textAlign: "center"}}>
              Nessuna Proiezione in Programma
              </div>
              :
                Array.isArray(movies) && movies.length > 0 ? 
                <Stack spacing={4}>
                  {Array.isArray(movies) && movies?.map(d => {
                  return (
                    <Grid item key={d.id}>
                      <MovieCardDesktop onTimeSlotClick={onTimeSlotClick} movieData={d}></MovieCardDesktop>
                    </Grid>)
                  
                  })}
                </Stack> : 
                <div style={{color: "#b3b3b3", margin: "4rem 0", width: "100%", textAlign: "center"}}>
                  Nessuna Proiezione in Programma
                </div>
                
                /*  CON PELLICOLA
                <Grid container spacing={2}>
                  <Grid item xs={0.5}>
                    <div style={{height: "100%", backgroundSize: "contain", backgroundRepeat:"repeat-y", backgroundImage: `url(${process.env.PUBLIC_URL}/images/pellicola.png)`}}></div>
                  </Grid>
                  <Grid item xs={11}>
                    <Stack spacing={4}>
                      {Array.isArray(movies) && movies?.map(d => {
                      return (
                        <Grid item key={d.id}>
                          <MovieCardDesktop onTimeSlotClick={onTimeSlotClick} movieData={d}></MovieCardDesktop>
                        </Grid>)
                      
                      })}
                    </Stack>
                  </Grid>
                  <Grid item xs={0.5}>
                  <div style={{height: "100%", backgroundSize: "contain", backgroundRepeat:"repeat-y", backgroundImage: `url(${process.env.PUBLIC_URL}/images/pellicola.png)`}}></div>
                  </Grid>
                </Grid>*/
              }
          </Stack>
        <BookPopup state={{data: BP_data, setData: BP_setData}} successCallback={() => {getMovies();}}></BookPopup>
        
    </>
  );
}
